// extracted by mini-css-extract-plugin
export var centerText = "_e3-8";
export var container = "_e3-0";
export var doughnutContainer = "_e3-7";
export var legend = "_e3-a";
export var legendItemColorDisplay = "_e3-b";
export var legendItemLabel = "_e3-d";
export var legendItemValue = "_e3-c";
export var lg = "_e3-5";
export var maxWidth = "_e3-9";
export var md = "_e3-4";
export var responsive = "_e3-6";
export var sm = "_e3-3";
export var xs = "_e3-2";
export var xxs = "_e3-1";